import { Stack, Typography, useTheme } from "@mui/material";
import { MultiPropertyData, MultiPropertyGroup } from "../../context/utils/computeElementsGroup";
import { FormPropertyComponent } from "../../FormProperty";
import { NestedMultivalue } from "./Nested/NestedMultivalue";

type MultiElementRowProps = {
    propertyData: MultiPropertyData;
    elementGroup: MultiPropertyGroup;
    level?: number;
};
export const MultiElementsRow = (props: MultiElementRowProps) => {
    const { elementGroup, level = 0, propertyData } = props;
    const theme = useTheme();

    const isDeeplyNestedMulti =
        propertyData.property.multivalue &&
        propertyData.property.children &&
        propertyData.property.children.length > 0 &&
        level < 2;

    if (isDeeplyNestedMulti) {
        return (
            <Stack>
                <NestedMultivalue
                    property={propertyData.property}
                    position={elementGroup.position}
                    dimensionValue={propertyData.subpropertyScore}
                    totalScore={null}
                    showSubscore={true}
                    // showSubscore={elementGroup.showSubscore}
                    level={level + 1}
                />
            </Stack>
        );
    }

    return (
        <Stack gap={theme.spacing(1)}>
            <Stack>
                <Typography
                    variant="body-semibold"
                    sx={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                    }}
                >
                    {propertyData.property.title}
                </Typography>
            </Stack>
            <FormPropertyComponent
                property={propertyData.property}
                position={elementGroup.position}
                dimensionValue={propertyData.subpropertyScore}
            />
        </Stack>
    );
};
